import { ActionCreator, AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'store';
import autoscalingGroupsService from 'services/api/customer/autoscaling-groups-service';
import {
  IAsgMemberResponseDto,
  IAsgResponseDto,
} from 'components/AutoscalingGroups/types/api-bodies.types';
import { ActionTypes, IAsgState } from './types/state.types';

export const setListOfAsgs: ActionCreator<AnyAction> = (payload: IAsgResponseDto[]) => ({
  type: ActionTypes.SET_LIST,
  payload,
});

export const setAsgMembers: ActionCreator<AnyAction> = (payload: IAsgState['members']) => ({
  type: ActionTypes.SET_MEMBERS,
  payload,
});

export const setAsgLoading: ActionCreator<AnyAction> = (payload: boolean) => ({
  type: ActionTypes.SET_LOADING,
  payload,
});

export const setAsgFailed: ActionCreator<AnyAction> = (payload: boolean) => ({
  type: ActionTypes.SET_FAILED,
  payload,
});

export type ThunkAsgDispatch = ThunkDispatch<RootState, void, AnyAction>;

export const fetchAsgList = (
  regionId: number,
  projectTag: string,
) => async (dispatch: ThunkAsgDispatch) => {
  const { data } = await autoscalingGroupsService.getAsgs(regionId, projectTag);
  const asgs = data.data;
  dispatch(setListOfAsgs(asgs));
  return asgs;
};

// Группы вместе с их участниками: по одной ВМ нельзя узнать её группу,
// поэтому состав групп держим в сторе и ищем участника по нему.
export const fetchAsgsWithMembers = (
  regionId: number,
  projectTag: string,
) => async (dispatch: ThunkAsgDispatch) => {
  dispatch(setAsgLoading(true));
  try {
    const { data } = await autoscalingGroupsService.getAsgs(regionId, projectTag);
    const asgs = data.data;
    dispatch(setListOfAsgs(asgs));

    const membersByAsg = await Promise.all(asgs.map((asg) => autoscalingGroupsService
      .getMembers(asg.id, regionId, projectTag)
      .then((res) => ({ asgId: asg.id, members: res.data.data }))
      .catch(() => ({ asgId: asg.id, members: [] as IAsgMemberResponseDto[] }))));

    dispatch(setAsgMembers(membersByAsg.reduce((total, { asgId, members }) => ({
      ...total,
      [asgId]: members,
    }), {} as IAsgState['members'])));
    dispatch(setAsgFailed(false));
    return asgs;
  } catch {
    dispatch(setAsgFailed(true));
    return [];
  } finally {
    dispatch(setAsgLoading(false));
  }
};
